import React from "react";
import { compose } from "redux";
import { SvgIcon } from "@material-ui/core";

import Helicopter from "app/components/Helicopter";

const HelicopterIcon = props => {
  return (
    <SvgIcon viewBox="0 0 1000 1000" {...props}>
      <Helicopter />
    </SvgIcon>
  );
};

export default compose()(HelicopterIcon);
